angular.module('am4').controller('renameCtrl', function($scope) {
    $scope.oldName = angular.copy($scope.name);
});



// WEBPACK FOOTER //
// ./src/app/controllers/renameCtrl.js